import React from "react";
import { PageWrapper } from "../../components/modules/wrapper";
import PageNotFound from "./PageNotFound";

export const PageNotFoundContainer = () => {
  return (
    <PageWrapper>
      <PageNotFound/>
    </PageWrapper>
  );
};
